import { TabRecordType } from './tabs';

// Keep in sync with AppLogSource, AppLogAction and AppLogEntityType in api/src/database/models/AppLog.ts

export const APP_LOG_SOURCE_LABELS: Record<string, string> = {
  WEB: 'Web',
  MOBILE: 'Mobile',
  ADMIN_MOBILE: 'Admin Mobile',
  SYSTEM: 'System',
  INTEGRATION: 'Integration'
};

export const APP_LOG_ACTION_LABELS: Record<string, string> = {
  CREATE: 'Create',
  UPDATE: 'Edit',
  DELETE: 'Delete',
  STATUS_CHANGE: 'Change Status',
  LOGIN: 'Login',
  LOGIN_FAILED: 'Failed Login',
  LOGOUT: 'Logout',
  SYNC: 'Sync',
  EXPORT: 'Export',
  SEND_EMAIL: 'Send Email'
};

export const APP_LOG_ENTITY_LABELS: Record<string, string> = {
  AGENT: 'Agent',
  APP_SETTING: 'Setting',
  BOOKING_SETTING: 'Booking Setting',
  BRAND_TEMPLATE: 'Brand Template',
  CHECKLIST: 'Checklist',
  CHECKLIST_ITEM: 'Checklist Item',
  CHECKLIST_TEMPLATE: 'Checklist Template',
  CLIENT: 'Client',
  CLIENT_DOCUMENT: 'Client Document',
  ENTITY: 'Entity',
  EQUIPMENT: 'Equipment',
  INVOICE: 'Invoice',
  JOB: 'Job',
  JOB_ACTION_TAG: 'Job Action Tag',
  JOB_ACTION_TAG_TEMPLATE: 'Job Action Tag Template',
  JOB_DOCUMENT: 'Job Document',
  JOB_EXPENSES: 'Job Expenses',
  JOB_EXPENSES_ITEM: 'Job Expenses Item',
  JOB_LABEL_TEMPLATE: 'Job Label Template',
  JOB_NOTE: 'Job Note',
  JOB_NOTE_TEMPLATE: 'Job Note Template',
  NOTIFICATION: 'Notification',
  PDF_TEMPLATE: 'PDF Template',
  RATING: 'Rating',
  ROLE: 'Role',
  SERVICE: 'Contract',
  SERVICE_ADDRESS: 'Service Address',
  SERVICE_ITEM: 'Service Item',
  SERVICE_ITEM_TEMPLATE: 'Service Item Template',
  SERVICE_TEMPLATE: 'Contract Template',
  SKILL_TEMPLATE: 'Skill Template',
  TIME_OFF: 'Time Off',
  USER: 'User',
  VEHICLE: 'Vehicle'
};

/** Records that have their own page, so the log can link to them */
export const APP_LOG_ENTITY_RECORD_TYPES: Record<string, TabRecordType> = {
  CLIENT: TabRecordType.CLIENT,
  INVOICE: TabRecordType.INVOICE,
  JOB: TabRecordType.JOB,
  SERVICE: TabRecordType.QUOTATION
};
